export default __webpack_public_path__ + "e82506aa828ee4666ccfca429cddfa15.png";